import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { PanierService } from '../manage/panier/panier.service';
import { ToolsService } from '../tools/tools.service';
import { PointofsaleService } from '../api/pointofsale/pointofsale.service';
import {SalemethodService} from "../api/salemethod/salemethod.service";

@Injectable({
  providedIn: 'root'
})

export class GuardEndorderService implements CanActivate {

  constructor(
    private manPan: PanierService,
    private tools: ToolsService,
    private posApi: PointofsaleService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): any {

    const that = this;

    return new Promise(function (resolve) {

      const storPOS:any = that.tools.getStor("point_of_sale");
      const storSM:any = that.tools.getStor(SalemethodService.TAG_STORAGE);
      const panier:any = that.manPan.initPanier();

      // Check if point of sale and sale method exists
      if (storPOS && storSM) {

        // Check if panier exist
        if (panier) {

          // Set shipping costs to point of sale if shipping cost is enable
          if (storSM.enable_shipping_cost > 0) {

            // that.posApi.getShippingPrices(storPOS.id).subscribe(data => {
              that.posApi.$_getShippingPrices(storPOS.id_webshop).subscribe(data => {

              storPOS.shipping_costs = data;

              that.tools.setStor("point_of_sale", storPOS);
              resolve(true);

            });

          } else if (storSM.enable_delivery > 0) {



              that.posApi.$_getEligibleCities(storPOS.id_webshop).then((data) => {


              storPOS.eligible_zones = data;


              that.tools.setStor("point_of_sale", storPOS);

              resolve(true);

            });

          } else {

            resolve(true);

          }

        } else {

          that.tools.goProductPage();
                 resolve(false);

        }

      } else {

        that.tools.goPointOfSalePage();
        resolve(false);

      }

    })
  }


}
